(() => {
  const initialize = () => {
    const header = document.getElementById('SiteHeader');
    if (!header || header.dataset.eoInitialized) return;
    header.dataset.eoInitialized = 'true';
    const items = [...header.querySelectorAll('.eo-nav__item')];
    const branches = [...header.querySelectorAll('.eo-nav__branch')];
    const hover = matchMedia('(hover: hover) and (pointer: fine)');
    const desktop = matchMedia('(min-width: 1200px)');
    const timers = new Map();
    const clear = item => {
      const timer = timers.get(item);
      if (timer) clearTimeout(timer);
      timers.delete(item);
    };
    const fit = () => {
      const bottom = header.getBoundingClientRect().bottom;
      const viewportBottom = window.visualViewport ? window.visualViewport.height + window.visualViewport.offsetTop : window.innerHeight;
      header.style.setProperty('--eo-nav-available', `${Math.max(0, viewportBottom - bottom - 12)}px`);
    };
    const sync = branch => branch.querySelector('summary').setAttribute('aria-expanded', String(branch.open));
    const close = branch => {
      clear(branch.closest('.eo-nav__item'));
      branch.open = false;
      sync(branch);
    };
    const open = branch => {
      if (!desktop.matches) return;
      branches.forEach(other => { if (other !== branch) close(other); });
      fit();
      branch.open = true;
      sync(branch);
    };
    items.forEach(item => {
      const branch = item.querySelector('.eo-nav__branch');
      if (!branch) return;
      const summary = branch.querySelector('summary');
      const panel = branch.querySelector('.eo-nav__panel');
      sync(branch);
      branch.addEventListener('toggle', () => {
        if (branch.open) {
          fit();
          branches.forEach(other => { if (other !== branch) close(other); });
        }
        sync(branch);
      });
      item.addEventListener('pointerenter', event => {
        if (!hover.matches || event.pointerType === 'touch' || item.closest('[data-eo-nav]').dataset.hoverEnabled !== 'true') return;
        clear(item);
        timers.set(item, setTimeout(() => open(branch), 350));
      });
      item.addEventListener('pointerleave', () => {
        clear(item);
        if (!panel.contains(document.activeElement)) timers.set(item, setTimeout(() => close(branch), 250));
      });
      item.addEventListener('focusout', event => {
        if (!item.contains(event.relatedTarget)) close(branch);
      });
      item.addEventListener('keydown', event => {
        if (event.key === 'Escape' && branch.open) {
          event.preventDefault();
          event.stopPropagation();
          close(branch);
          summary.focus();
        }
        if (event.key === 'ArrowDown' && (event.target === summary || event.target === item.firstElementChild)) {
          event.preventDefault();
          open(branch);
          panel.querySelector('a')?.focus();
        }
      });
      item.addEventListener('keyup', event => {
        if (event.key === 'Escape') event.stopPropagation();
      });
      summary.addEventListener('click', () => clear(item));
    });
    document.addEventListener('pointerdown', event => {
      if (!event.target.closest('.eo-nav__item')) branches.forEach(close);
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') branches.forEach(close);
    });
    document.querySelectorAll('.js-drawer-open-nav, .js-search-header, .js-drawer-open-cart').forEach(control => control.addEventListener('click', () => branches.forEach(close)));
    window.addEventListener('resize', () => {
      if (!desktop.matches) branches.forEach(close);
      fit();
    }, {passive: true});
    window.addEventListener('scroll', () => {
      if (branches.some(branch => branch.open)) requestAnimationFrame(fit);
    }, {passive: true});
    window.visualViewport?.addEventListener('resize', fit, {passive: true});
    new ResizeObserver(fit).observe(header);
    fit();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();


(() => {
  let dispose;
  const initializeSticky = () => {
    dispose?.();
    const header = document.getElementById('SiteHeader');
    if (!header || header.dataset.eoSticky !== 'true') return;
    const wrapper = header.closest('.header-sticky-wrapper');
    if (!wrapper) return;
    const root = document.documentElement;
    const priorSticky = window.theme?.config?.stickyHeader;
    if (window.theme?.config) window.theme.config.stickyHeader = true;
    const mobile = matchMedia('(max-width: 1199px)');
    const abort = new AbortController();
    const options = { passive: true, signal: abort.signal };
    let origin = 0;
    let height = 0;
    let previousY = Math.max(0, window.scrollY);
    let travel = 0;
    let frame = 0;
    let inspector = false;
    const keepVisible = () => header.contains(document.activeElement) || !!header.querySelector('.site-header__search-container.is-active, details[open]') || !!document.querySelector('.drawer--is-open');
    const update = () => {
      frame = 0;
      const y = Math.max(0, window.scrollY);
      const fixed = y > origin && !inspector;
      header.classList.toggle('eo-header--fixed', fixed);
      if (!fixed || !mobile.matches || y < origin + height || keepVisible()) {
        header.classList.remove('eo-header--hidden');
        travel = 0;
      } else {
        const delta = y - previousY;
        if (delta) {
          travel = Math.sign(delta) === Math.sign(travel) ? travel + delta : delta;
          if (travel > 16) header.classList.add('eo-header--hidden');
          if (travel < -8) header.classList.remove('eo-header--hidden');
        }
      }
      previousY = y;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const measure = () => {
      height = header.offsetHeight;
      origin = wrapper.getBoundingClientRect().top + window.scrollY;
      wrapper.style.height = `${height}px`;
      root.style.setProperty('--eo-sticky-height', `${height}px`);
      schedule();
    };
    root.classList.add('eo-sticky-navigation');
    window.addEventListener('scroll', schedule, options);
    window.addEventListener('resize', measure, options);
    window.addEventListener('pageshow', measure, options);
    window.visualViewport?.addEventListener('resize', measure, options);
    header.addEventListener('focusin', () => { header.classList.remove('eo-header--hidden'); travel = 0; }, { signal: abort.signal });
    document.addEventListener('shopify:inspector:activate', () => { inspector = true; schedule(); }, { signal: abort.signal });
    document.addEventListener('shopify:inspector:deactivate', () => { inspector = false; measure(); }, { signal: abort.signal });
    const resize = new ResizeObserver(measure);
    resize.observe(header);
    const toolbar = wrapper.previousElementSibling;
    if (toolbar) resize.observe(toolbar);
    const mutations = new MutationObserver(schedule);
    mutations.observe(root, { attributes: true, attributeFilter: ['class'] });
    mutations.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    const search = header.querySelector('.site-header__search-container');
    if (search) mutations.observe(search, { attributes: true, attributeFilter: ['class'] });
    measure();
    dispose = () => {
      abort.abort();
      resize.disconnect();
      mutations.disconnect();
      cancelAnimationFrame(frame);
      header.classList.remove('eo-header--fixed', 'eo-header--hidden');
      wrapper.style.removeProperty('height');
      root.classList.remove('eo-sticky-navigation');
      root.style.removeProperty('--eo-sticky-height');
      if (window.theme?.config) window.theme.config.stickyHeader = priorSticky;
    };
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeSticky);
  else initializeSticky();
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('#SiteHeader')) initializeSticky();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('#SiteHeader')) dispose?.();
  });
})();
